import { createApi } from "@reduxjs/toolkit/query/react";
import { GOODS_DELIVERY_NOTE } from "@utils/constants/goods-request/delivery-note.constants";
import { baseQueryWithReauth } from "@states/auth/auth.api";

export const deliveryNoteApi = createApi({
  reducerPath: "deliveryNoteApi",
  tagTypes: ["DeliveryNote"],
  baseQuery: baseQueryWithReauth,
  endpoints: (builder) => ({
    getAllDeliveryNotes: builder.query<
      [],
      {
        page?: number;
        limit?: number;
        customer_first_name?: string;
        direct_sales_invoice_code?: string;
        direct_sales_return_code?: string;
        search?: string;
      }
    >({
      query: ({
        page = 1,
        limit = 10,
        search,
      }) => {
        const queryParams = {
          url: GOODS_DELIVERY_NOTE.GET_ALL,
          params: { page, limit },
        } as any;

        if (search) {
          queryParams.params.search = search;
        }

        return queryParams;
      },
    }),
    getGoodsDelivery: builder.query<
      any,
      { goods_delivery_id: string | number }
    >({
      query: ({ goods_delivery_id }) =>
        `${GOODS_DELIVERY_NOTE.GET_ONE}${goods_delivery_id}`,
    }),
    updateGoodsDelivery: builder.mutation({
      query: ({ id, body }) => ({
        url: `${GOODS_DELIVERY_NOTE.UPDATE}${id}`,
        method: "PATCH",
        body,
      }),
    }),
    deleteGoodsDelivery: builder.mutation({
      query: ({ id }) => ({
        url: `${GOODS_DELIVERY_NOTE.DELETE}${id}`,
        method: "DELETE",
      }),
    }),
  }),
  keepUnusedDataFor: 0,
});

export const {
  useGetAllDeliveryNotesQuery,
  useGetGoodsDeliveryQuery,
  useLazyGetGoodsDeliveryQuery,
  useUpdateGoodsDeliveryMutation,
  useDeleteGoodsDeliveryMutation,
} = deliveryNoteApi;
